import { useSelector } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import { authSelector } from "../../store";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const { isLoggedIn } = useSelector(authSelector);

  if (!isLoggedIn) {
    return (
      <Navigate replace to="/auth/sign_in" state={{ from: location }} />
    );
  }

  return children;
}
